"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeElement = void 0;
function activeElement(doc) {
  if (doc === void 0) {
    doc = document;
  }
  try {
    return doc.activeElement;
  } catch (e) {
    // Empty
  }
}
exports.activeElement = activeElement;